import React from 'react';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import logo from '../images/Petcrew_logo.png';

function Header() {
  return (
    <Navbar expand="lg">
      <Container>
        <Navbar.Brand>
          <Link to="/">
            <img src={logo} alt="logo" />
          </Link>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <div className="funeral-button">
            <Link to="/funeral" className="btn">For Funeral</Link>
            {/* <button className="btn">Call for Funeral</button> */}
          </div>
          <Nav className="me-auto">
          <Nav.Link as={Link} to="/">Home</Nav.Link>
            <Nav.Link as={Link} to="/all-dog-breed">All Pets</Nav.Link>
            <Nav.Link as={Link} to="/heart-of-the-story">Heart of the Story</Nav.Link>
            <Nav.Link as={Link} to="/food">Food</Nav.Link> 
             {/* <Nav.Link as={Link} to="/food">Food</Nav.Link> */}
            {/* <Nav.Link as={Link} to="/contact-us">Contact Us</Nav.Link> */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
